import axios from "axios";
import moment from "moment";
import { getAccessToken, getLiteCompanyId, getUserId } from "./utils.js";
import { getUrl } from "./urls";
import { toast } from "react-toastify";
import { formatCompetitorsData } from "./competitorInsightsActionsUtils.js";

export const UPDATE_COMPETITOR_DURATION_FILTER = "UPDATE_COMPETITOR_DURATION_FILTER";
export const SET_COMPETITOR_NAME = "SET_COMPETITOR_NAME";
export const SET_COMPETITOR_PLATFORM = "SET_COMPETITOR_PLATFORM";
export const SET_COMPETITOR_LOCATION = "SET_COMPETITOR_LOCATION";
export const SET_COMPETITOR_URL = "SET_COMPETITOR_URL";
export const SET_COMPETITOR_ENTITY = "SET_COMPETITOR_ENTITY";
export const VALIDATE_COMPETITOR_ACCOUNT = "VALIDATE_COMPETITOR_ACCOUNT";
export const SET_VALID_COMPETITOR_ACCOUNT = "SET_VALID_COMPETITOR_ACCOUNT";
export const CREATE_COMPETITOR_RULE = "CREATE_COMPETITOR_RULE";
export const JOIN_COMPETITOR_ACCOUNT = "JOIN_COMPETITOR_ACCOUNT";
export const FETCH_COMPETITOR_LIST = "FETCH_COMPETITOR_LIST";
export const FETCH_COMP_TABLE_CHART_DATA = "FETCH_COMP_TABLE_CHART_DATA";
export const DELETE_COMPETITOR_ACCOUNT = "DELETE_COMPETITOR_ACCOUNT";
export const SET_EDIT_COMPETITOR = "SET_EDIT_COMPETITOR";
export const FETCH_COMPETITOR_POSTS = "FETCH_COMPETITOR_POSTS";
export const SET_COMPETITOR_FILTER = "SET_COMPETITOR_FILTER";
export const SET_SELECTED_COMPETITORS = "SET_SELECTED_COMPETITORS";
export const FETCH_COMPETITOR_POSTS_COUNT = "FETCH_COMPETITOR_POSTS_COUNT";
export const FETCH_COMPETITOR_IMPACT_SCORE = "FETCH_COMPETITOR_IMPACT_SCORE";
export const SET_EXISTING_COMPETITOR_NAME = "SET_EXISTING_COMPETITOR_NAME";

const capitalizeFirstLetter = (str, locale = navigator.language) => {
    return str?.replace(/^\p{CWU}/u, (char) => char.toLocaleUpperCase(locale));
};

export function fetchCompetitorList() {
    let res = axios({
        method: "get",
        url: `${getUrl("query_list")}&access-token=${getAccessToken()}&includes=topicsAndSubtopics`,
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => {
            let accounts = [];
            let accountlist = res.data?.data?.filters?.topicsAndSubtopics?.filter((account) => account?.config_source?.toLowerCase() === "competitor");
            accountlist?.map((ac) => {
                const research_query_id = ac?.research_query_id;
                const subtopic_id = ac?.subtopic_id;
                const modified_date = ac?.modified_date;
                const allAccounts = JSON.parse(ac?.accounts);

                allAccounts?.map((act) => {
                    if (act.config_type === "tiktok_account") {
                        const platform = "tiktok";
                        const userName = act.query_filter;
                        const country = act.location_short_name;
                        const entity = act.entity_sub_type;
                        const name = act.competitor_name;
                        accounts.push({
                            name,
                            platform,
                            userName,
                            country,
                            research_query_id,
                            subtopic_id,
                            entity,
                            modified_date,
                        });
                    } else {
                        const stringArray = act.value.split(":");
                        const platform = stringArray[0];
                        const userName = stringArray[1].split(",")[0];
                        const country = stringArray[4].split(",")[0];
                        const entity = stringArray[5].split(",")[0];
                        const name = stringArray[stringArray.length - 1];
                        accounts.push({
                            name,
                            platform,
                            userName,
                            country,
                            research_query_id,
                            subtopic_id,
                            entity,
                            modified_date,
                            label: `${name} (${capitalizeFirstLetter(platform)})`,
                            value: research_query_id,
                        });
                    }
                });
            });
            // accounts = accounts.sort((a, b) => moment(b.modified_date) - moment(a.modified_date));
            accounts = accounts.sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : b.name.toLowerCase() > a.name.toLowerCase() ? -1 : 0));
            return accounts;
        })
        .catch((err) => {
            toast.error(err.response?.data?.message);
            return err;
        });
    return {
        type: "FETCH_COMPETITOR_LIST",
        payload: res,
    };
}

export function deleteCompetitorAccount(param) {
    let new_param = {};
    new_param["research_query_id"] = param.research_query_id;
    return function (dispatch) {
        axios
            .delete(`${getUrl("rule_delete")}${param.id}?access-token=${getAccessToken()}`, {
                cache: false,
                headers: { "Content-Type": "application/json" },
            })
            .then((res) => {
                dispatch({
                    type: "DELETE_COMPETITOR_ACCOUNT",
                    payload: res,
                });
                toast.success("Account deleted successfully");
                dispatch(deleteAccount(new_param));
            })
            .catch((err) => {
                toast.error(err.response.data.message);
                throw err;
            });
    };
}

export function deleteAccount(data) {
    return function (dispatch) {
        axios
            .post(getUrl("delete_account"), data, {
                cache: false,
                headers: { "Content-Type": "application/json;charset=UTF-8" },
            })
            .then((res) => {
                dispatch(fetchCompetitorList());
            })
            .catch((err) => {
                toast.error(err.response?.data?.message);
                return err;
            });
    };
}

export const fetchCompetitorTableData = (arg) => {
    const { accountList, filter } = arg;

    if (accountList?.length === 0) return;

    return function (dispatch) {
        dispatch({ type: "FETCH_COMP_TABLE_CHART_DATA_PENDING" });

        let tableList;
        const engagementPromiseArray = accountList.map((account) =>
            fetchCompetitorEngagementData(filter, account?.userName, account?.platform, account?.research_query_id),
        );
        let engagementDataPromise = Promise.all(engagementPromiseArray);

        engagementDataPromise.then((engagementData) => {
            let pages = engagementData.map((account) => {
                return { username: account?.handler, platform: account?.platform };
            });
            pages = pages.filter(Boolean);
            const params = {};

            params["users"] = pages;
            params["start_date"] = filter.startDateTime;
            params["end_date"] = filter.endDateTime;

            fetchCompetitorFollower(params).then((followerData) => {
                tableList = engagementData.map((el) => {
                    const nameObj = accountList?.find((ac) => ac?.research_query_id === el?.research_query_id);
                    const followersObj = followerData?.find((ac) => ac?.username === el?.handler && ac?.platform === el?.platform);

                    const userName = nameObj?.userName;
                    const name = nameObj?.name;
                    const entity = nameObj?.entity;
                    const country = nameObj?.country;
                    const followersCount = followersObj?.followers;
                    const followersGrowth = followersObj?.followersGrowth;
                    const platform = nameObj?.platform;
                    const subtopic_id = nameObj?.subtopic_id;
                    const modified_date = nameObj?.modified_date;
                    const research_query_id = nameObj?.research_query_id;

                    return {
                        ...el,
                        userName,
                        name,
                        followersCount,
                        followersGrowth,
                        entity,
                        country,
                        platform,
                        subtopic_id,
                        modified_date,
                        label: `${name} (${capitalizeFirstLetter(platform)})`,
                        value: research_query_id,
                    };
                });

                tableList = tableList.filter(Boolean);
                tableList = tableList.filter((ac) => ac.userName !== undefined);
                tableList = tableList.sort((a, b) => moment(b.modified_date) - moment(a.modified_date));

                dispatch({
                    type: "FETCH_COMP_TABLE_CHART_DATA_FULFILLED",
                    payload: tableList,
                });
            });
        });
    };
};

export const fetchCompetitorEngagementData = (filter, handler, platform, query_id) => {
    let params = new URLSearchParams();

    params.append("start_date", filter.startDateTime);
    params.append("end_date", filter.endDateTime);
    params.append("data", "0");
    params.append("orderBy", "impact_value");
    params.append("order", "desc");
    params.append("offset", "1");
    params.append("recordsPerPage", "0");
    params.append("post_type", "0");
    // params.append("custom_query", `post.page_id:${selectedPage}`);
    params.append("custom_query", `handlers.value:"${handler}"`);
    params.append("aggs-interval", "year");
    // params.append("aggs", "total_impact_value,view_datewise_breakdown,impressions_datewise_breakdown");
    params.append(
        "aggs",
        "total_impact_value,likes_datewise_breakdown,comments_datewise_breakdown,shares_datewise_breakdown,view_datewise_breakdown,total_estimated_reach",
    );
    if (platform === "facebook") params.append("platform", ["6ce338bd-a789-11e4-a34f-74867a1157ba"]);
    else params.append("platform", ["6ce32c0a-a789-11e4-a34f-74867a1157ba"]);

    let res = axios
        .post(getUrl("searchaggs"), params, {
            cache: false,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            },
        })
        .then((response) => {
            const data = {
                engagement: response.data?.aggregations?.total_impact_value?.value,
                // impressions: getTotalVal(response.data?.aggregations?.impressions_datewise_breakdown),
                // reach: getTotalVal(response.data?.aggregations?.view_datewise_breakdown),
                reach: response.data?.aggregations?.total_estimated_reach?.value,
                totalEngagement: getEngagement("engagement", response.data?.aggregations),
                impression: getEngagement("impression", response.data?.aggregations),
                posts: response.data?.hits?.total,
                handler: handler,
                research_query_id: query_id,
                platform,
            };
            return data;
        })
        .catch((error) => {
            console.log(error);
        });

    return res;
};

// const getTotalVal = (arr) => {
//     if (!arr) return;

//     return arr.buckets.reduce((agg, a) => agg + a.data_stats.sum, 0);
// };
const getEngagement = (type, data) => {
    if (!data) return 0;
    if (type === "impression") return data?.view_datewise_breakdown?.buckets?.reduce((agg, a) => agg + a.data_stats.sum, 0);

    return (
        data?.likes_datewise_breakdown?.buckets?.reduce((agg, a) => agg + a.data_stats.sum, 0) +
        data.comments_datewise_breakdown?.buckets?.reduce((agg, a) => agg + a.data_stats.sum, 0) +
        data?.shares_datewise_breakdown.buckets?.reduce((agg, a) => agg + a.data_stats.sum, 0)
    );

    // return data.buckets.reduce((agg, a) => agg + a.data_stats.sum, 0);
};

const truncate = (str, max = 80) => {
    const ellipsis = str?.length > max ? "..." : "";
    return str?.slice(0, max) + ellipsis;
};
const fetchRecentCompPostsPromise = (arg, currentSelectedComp, chartType = null) => {
    const { filter, postOrder, postOrderBy, chartKey } = arg;
    let platform = currentSelectedComp.platform;
    let handler = currentSelectedComp.userName;
    // let query_id= currentSelectedComp.research_query_id

    let params = new URLSearchParams();
    let order, orderBy;
    order = postOrder;
    orderBy = postOrderBy;

    params.append("start_date", filter.startDateTime);
    params.append("end_date", filter.endDateTime);
    // params.append("data", "1");
    params.append("orderBy", orderBy);
    params.append("order", order);
    // params.append("offset", "1");
    // params.append("recordsPerPage", "50");
    params.append("post_type", "0");
    params.append("custom_query", `handlers.value:"${handler}"`);
    // params.append("custom_query", `post.page_id:${selectedPage}`);
    if (platform === "facebook") params.append("platform", ["6ce338bd-a789-11e4-a34f-74867a1157ba"]);
    if (platform === "twitter") params.append("platform", ["6ce32a97-a789-11e4-a34f-74867a1157ba"]);
    if (platform === "instagram") params.append("platform", ["6ce32c0a-a789-11e4-a34f-74867a1157ba"]);
    if (chartType) {
        params.append("data", "0");
        params.append("offset", "0");
        params.append("recordsPerPage", "0");

        if (chartType === "hashtag") {
            params.append("aggs", "by_hashtags");
        } else if (chartType === "impactScore") {
            params.append("aggs", "total_impact_value");
        }
    } else {
        params.append("data", "1");
        params.append("offset", "1");
        params.append("recordsPerPage", "50");
    }
    if (chartKey === "compRecentPosts") {
        params.append("exclude_post_subtypes", "story");
    }

    return axios.post(getUrl("searchaggs"), params, {
        cache: false,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
    });
};
export const fetchCompetitorPosts = (arg) => {
    return function (dispatch) {
        const selectedCompetitors = arg.selectedCompetitorAccountLists;
        let promises = selectedCompetitors.map((obj) =>
            fetchRecentCompPostsPromise(arg, obj).then((data) => ({
                data: data.data,
                obj: obj,
            })),
        );

        // let res = axios
        //     .post(getUrl("searchaggs"), params, {
        //         cache: false,
        //         headers: {
        //             "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        //         },
        //     })
        dispatch({
            type: "FETCH_COMPETITOR_POSTS_PENDING",
            // payload: query_id,
        });
        Promise.all(promises)
            .then((response) => {
                // console.log("datataaa", response);
                let data = formatCompetitorsData("compRecentPosts", response, arg);
                // console.log("datataaa 22222", data);
                // return data;
                dispatch({
                    type: "FETCH_COMPETITOR_POSTS_FULFILLED",
                    payload: data,
                });
            })
            .catch((error) => {
                console.log(error);
                dispatch({
                    type: "FETCH_COMPETITOR_POSTS_REJECTED",
                    // payload: query_id,
                });
            });

        // return {
        //     type: "FETCH_COMPETITOR_POSTS",
        //     payload: res,
        // };
    };
};

export const fetchCompetitorTotalPosts = (arg) => {
    // console.log("datataaa 111", arg);

    return function (dispatch) {
        const selectedCompetitors = arg.selectedCompetitorAccountLists;
        let promises = selectedCompetitors.map((obj) =>
            fetchRecentCompPostsPromise(arg, obj).then((data) => ({
                data: data.data,
                obj: obj,
            })),
        );

        dispatch({
            type: "FETCH_COMPETITOR_POSTS_COUNT_PENDING",
            // payload: query_id,
        });
        Promise.all(promises)
            .then((response) => {
                // console.log("datataaa", response);
                let data = formatCompetitorsData("compPostCount", response, arg);

                dispatch({
                    type: "FETCH_COMPETITOR_POSTS_COUNT_FULFILLED",
                    payload: data,
                });
            })
            .catch((error) => {
                console.log(error);
                dispatch({
                    type: "FETCH_COMPETITOR_POSTS_COUNT_REJECTED",
                });
            });
    };
};
export const fetchCompetitorImpactValue = (arg) => {
    return function (dispatch) {
        const selectedCompetitors = arg.selectedCompetitorAccountLists;
        let promises = selectedCompetitors.map((obj) =>
            fetchRecentCompPostsPromise(arg, obj, "impactScore").then((data) => ({
                data: data.data,
                obj: obj,
            })),
        );

        dispatch({
            type: "FETCH_COMPETITOR_IMPACT_SCORE_PENDING",
        });
        Promise.all(promises)
            .then((response) => {
                // console.log("datataaa", response);
                let data = formatCompetitorsData("compImpactScore", response, arg);

                dispatch({
                    type: "FETCH_COMPETITOR_IMPACT_SCORE_FULFILLED",
                    payload: data,
                });
            })
            .catch((error) => {
                console.log(error);
                dispatch({
                    type: "FETCH_COMPETITOR_IMPACT_SCORE_REJECTED",
                });
            });
    };
};

export const fetchCompetitorByHashtags = (arg) => {
    return function (dispatch) {
        const selectedCompetitors = arg.selectedCompetitorAccountLists;
        let promises = selectedCompetitors.map((obj) =>
            fetchRecentCompPostsPromise(arg, obj, "hashtag").then((data) => ({
                data: data.data,
                obj: obj,
            })),
        );

        dispatch({
            type: "FETCH_COMPETITOR_BY_HASHTAGS_PENDING",
        });
        Promise.all(promises)
            .then((response) => {
                // console.log("datataaa", response);
                let data = formatCompetitorsData("compByHashtags", response, arg);

                dispatch({
                    type: "FETCH_COMPETITOR_BY_HASHTAGS_FULFILLED",
                    payload: data,
                });
            })
            .catch((error) => {
                console.log(error);
                dispatch({
                    type: "FETCH_COMPETITOR_BY_HASHTAGS_REJECTED",
                });
            });
    };
};

// export const fetchCompetitorByHashtags = (arg) => {
//     const { filter, handler, platform } = arg;

//     let params = new URLSearchParams();

//     params.append("start_date", filter.startDateTime);
//     params.append("end_date", filter.endDateTime);
//     params.append("data", "1");
//     params.append("orderBy", "post.published_date");
//     params.append("order", "desc");
//     params.append("offset", "1");
//     params.append("recordsPerPage", "50");
//     params.append("custom_query", `handlers.value:"${handler}"`);
//     params.append("post_type", "0");
//     params.append("aggs", "by_hashtags");
//     if (platform === "facebook") params.append("platform", ["6ce338bd-a789-11e4-a34f-74867a1157ba"]);
//     if (platform === "twitter") params.append("platform", ["6ce32a97-a789-11e4-a34f-74867a1157ba"]);
//     if (platform === "instagram") params.append("platform", ["6ce32c0a-a789-11e4-a34f-74867a1157ba"]);

//     let res = axios
//         .post(getUrl("searchaggs"), params, {
//             cache: false,
//             headers: {
//                 "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
//             },
//         })
//         .then((response) => {
//             return response.data?.aggregations?.by_hashtags?.buckets || [];
//         })
//         .catch((error) => {
//             console.log(error);
//         });

//     return {
//         type: "FETCH_COMPETITOR_BY_HASHTAGS",
//         payload: res,
//     };
// };

export const fetchCompetitorByEngagement = (arg) => {
    return function (dispatch) {
        const { filter, handler, platform } = arg;

        let params = new URLSearchParams();

        const aggs_val = arg.aggs_val;

        let interval;
        if (aggs_val) {
            if (aggs_val === "yearly") interval = "year";
            else if (aggs_val === "monthly") interval = "month";
            else if (aggs_val === "weekly") interval = "week";
            else interval = "day";
        }

        params.append("start_date", filter.startDateTime);
        params.append("end_date", filter.endDateTime);
        params.append("data", "1");
        params.append("orderBy", "post.published_date");
        params.append("order", "desc");
        params.append("offset", "1");
        params.append("recordsPerPage", "50");
        params.append("custom_query", `handlers.value:"${handler}"`);
        params.append("post_type", "0");
        params.append("aggs-interval", interval);
        params.append("aggs", "likes_datewise_breakdown,comments_datewise_breakdown,shares_datewise_breakdown");
        if (platform === "facebook") params.append("platform", ["6ce338bd-a789-11e4-a34f-74867a1157ba"]);
        if (platform === "twitter") params.append("platform", ["6ce32a97-a789-11e4-a34f-74867a1157ba"]);
        if (platform === "instagram") params.append("platform", ["6ce32c0a-a789-11e4-a34f-74867a1157ba"]);
        let query_id = arg.query_id;
        dispatch({
            type: "FETCH_COMPETITOR_BY_ENGAGEMENTS_PENDING",
            payload: query_id,
        });
        let res = axios
            .post(getUrl("searchaggs"), params, {
                cache: false,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            })
            .then((response) => {
                let obj = {
                    nodata: response.data.hits.total === 0,
                    likes_agg: [],
                    likes_avg: 0,
                    comments_agg: [],
                    comments_avg: 0,
                    shares_agg: [],
                    shares_avg: 0,
                    views_agg: [],
                    views_avg: 0,
                    total_agg: [],
                    total_avg: 0,
                    min: Number.MAX_SAFE_INTEGER,
                    max: Number.MIN_SAFE_INTEGER,
                };

                let totallength = response.data.hits.total || 1;

                let total = 0;
                let totalInd = 0;
                let total_agg = {};
                let tz = JSON.parse(localStorage.company).user_timezone_name;

                response.data.aggregations.likes_datewise_breakdown.buckets.forEach((likes) => {
                    let d = +moment(likes.key).tz(tz).format("x");
                    obj.likes_agg.push([d, likes.data_stats.sum || 0]);
                    total_agg[d] = likes.data_stats.sum;
                    totalInd += likes.data_stats.sum;
                });
                obj.likes_avg = +(totalInd / totallength).toFixed(2);
                total += totalInd;

                totalInd = 0;
                response.data.aggregations.comments_datewise_breakdown.buckets.forEach((comments) => {
                    let d = +moment(comments.key).tz(tz).format("x");
                    obj.comments_agg.push([d, comments.data_stats.sum || 0]);
                    totalInd += comments.data_stats.sum;
                    total_agg[d] += comments.data_stats.sum;
                });
                obj.comments_avg = +(totalInd / totallength).toFixed(2);
                total += totalInd;

                totalInd = 0;
                response.data.aggregations.shares_datewise_breakdown.buckets.forEach((shares) => {
                    let d = +moment(shares.key).tz(tz).format("x");
                    obj.shares_agg.push([d, shares.data_stats.sum || 0]);
                    totalInd += shares.data_stats.sum;
                    total_agg[d] += shares.data_stats.sum;
                });
                obj.shares_avg = +(totalInd / totallength).toFixed(2);
                total += totalInd;

                totalInd = 0;
                response.data.aggregations?.view_datewise_breakdown?.buckets.forEach((views) => {
                    let d = +moment(views.key).tz(tz).format("x");
                    obj.views_agg.push([d, views.data_stats.sum || 0]);
                    totalInd += views.data_stats.sum;
                    total_agg[d] += views.data_stats.sum;
                });
                obj.views_avg = +(totalInd / totallength).toFixed(2);
                total += totalInd;

                obj.total_agg = Object.entries(total_agg).map(([k, v]) => {
                    obj.max = Math.max(obj.max, v);
                    obj.min = Math.min(obj.min, v);

                    return [+k, v || 0];
                });

                obj.total_avg = +(total / totallength).toFixed(2);
                if (obj.total_avg + obj.shares_avg + obj.likes_avg + obj.comments_avg + obj.views_avg < 1) obj.nodata = true;

                // return obj;
                dispatch({
                    type: "FETCH_COMPETITOR_BY_ENGAGEMENTS_FULFILLED",
                    payload: { ...obj, query_id },
                });
            })
            .catch((error) => {
                console.log(error);
                dispatch({
                    type: "FETCH_COMPETITOR_BY_ENGAGEMENTS_REJECTED",
                    payload: query_id,
                });
            });

        // return {
        //     type: "FETCH_COMPETITOR_BY_ENGAGEMENTS",
        //     payload: res,
        // };
    };
};

const fetchFollowersCount = (params) => {
    return axios.post(getUrl("competitor_follower"), params, {
        cache: false,
        headers: {
            "Content-Type": "application/json",
        },
    });
};

export const fetchCompetitorFollower = async (params) => {
    try {
        const presentDurationData = fetchFollowersCount(params).then((res) => ({ name: "presentDurationData", data: res.data?.results }));

        let prevData = { ...params };
        const durationGap = moment(params.end_date).diff(moment(params.start_date), "days", true);
        prevData["start_date"] = moment(params.start_date)
            .subtract(durationGap + 1, "days")
            .startOf("day")
            .format("YYYY-MM-DD");
        prevData["end_date"] = moment(params.start_date).subtract(1, "day").format("YYYY-MM-DD");

        const previousDurationData = fetchFollowersCount(prevData).then((res) => ({ name: "previousDurationData", data: res.data?.results }));
        const result = await Promise.all([presentDurationData, previousDurationData]).then((response) => {
            return formatFollowersCount(response);
        });

        return result;
    } catch (error) {
        console.log(error);
    }

    // let res = axios
    //     .post(getUrl("competitor_follower"), params, {
    //         cache: false,
    //         headers: {
    //             "Content-Type": "application/json",
    //         },
    //     })
    //     .then((response) => {
    //         const followersCountData = response.data?.results?.map((ac) => {
    //             const page = ac.username;
    //             const followers = ac.follower_info?.total;
    //             const platform = ac.platform;
    //             return { page: page, followers: followers, platform };
    //         });

    //         const followersGrowthData = response.data?.data?.followers_growth?.map((ac) => {
    //             const page = ac.username;
    //             const growth = ac.count;
    //             const platform = ac.platform;
    //             return { page: page, growth: growth, platform };
    //         });
    //         let mergedData = followersCountData?.map((ac) => {
    //             const commonAc = followersGrowthData?.find((el) => ac.page === el.page && ac.platform === el.platform);
    //             if (commonAc) {
    //                 return { page: commonAc.page, followers: ac.followers, followersGrowth: commonAc.growth, platform: commonAc.platform };
    //             }
    //         });
    //         mergedData = mergedData?.filter(Boolean);
    //         return mergedData;
    //     })
    //     .catch((error) => {
    //         console.log(error);
    //     });

    // return res;
};

export function updateDurationFilter(value) {
    return {
        type: "UPDATE_COMPETITOR_DURATION_FILTER",
        payload: value,
    };
}
export function setCompetitorName(value) {
    return {
        type: "SET_COMPETITOR_NAME",
        payload: value,
    };
}
export function setExistingCompetitorName(value) {
    return {
        type: "SET_EXISTING_COMPETITOR_NAME",
        payload: value,
    };
}
export function setCompetitorPlatform(value) {
    return {
        type: "SET_COMPETITOR_PLATFORM",
        payload: value,
    };
}
export function setCompetitorLocation(value) {
    return {
        type: "SET_COMPETITOR_LOCATION",
        payload: value,
    };
}
export function setCompetitorUrl(value) {
    return {
        type: "SET_COMPETITOR_URL",
        payload: value,
    };
}
export function setCompetitorEntity(value) {
    return {
        type: "SET_COMPETITOR_ENTITY",
        payload: value,
    };
}

export function setValidCompetitorAccount(value) {
    return {
        type: "SET_VALID_COMPETITOR_ACCOUNT",
        payload: value,
    };
}

export function setEditCompetitor(value) {
    return {
        type: "SET_EDIT_COMPETITOR",
        payload: value,
    };
}

export function setSelectedCompetitors(value) {
    return {
        type: "SET_SELECTED_COMPETITORS",
        payload: value,
    };
}

export function validateCompetitorAccount(param) {
    let res = axios({
        method: "post",
        url: getUrl("validate_account"),
        data: param,
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => {
            if (res.data.status) {
                toast.success("Account verified successfully. Please proceed for further steps");
            } else {
                toast.error("Account is not valid");
            }
            return res.data;
        })
        .catch((err) => {
            toast.error(err.response.data.message);
            return err;
        });

    return {
        type: VALIDATE_COMPETITOR_ACCOUNT,
        payload: res,
    };
}

export function createCompetitorRule(param) {
    param["access-token"] = getAccessToken();
    let updateQuery = false;
    const new_param = {};
    if (param["subtopic_id"]) {
        updateQuery = true;
    }
    new_param["accounts"] = param["accountList"];
    new_param["update_query"] = updateQuery;
    delete param.accountList;
    return function (dispatch) {
        dispatch({
            type: "CREATE_COMPETITOR_RULE_PENDING",
        });
        let res = axios({
            method: "post",
            url: getUrl("rule_create"),
            data: param,
            cache: false,
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then((res) => {
                dispatch({
                    type: "CREATE_COMPETITOR_RULE_FULFILLED",
                    payload: res.data,
                });

                new_param["research_query_id"] = res.data.data.id;
                dispatch(addCompetitorAccountAfterCreateRule(new_param));
                return res.data;
            })
            .catch((err) => {
                console.error(err);
                dispatch({
                    type: "CREATE_COMPETITOR_RULE_REJECTED",
                    payload: err,
                });
                throw err;
            });
    };
}

export function addCompetitorAccountAfterCreateRule(param) {
    let updateQuery = param["update_query"];
    delete param.update_query;
    return function (dispatch) {
        dispatch({
            type: "JOIN_COMPETITOR_ACCOUNT_PENDING",
        });
        let res = axios({
            method: "post",
            url: getUrl("add_account"),
            data: param,
            cache: false,
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then((res) => {
                dispatch({
                    type: "JOIN_COMPETITOR_ACCOUNT_FULFILLED",
                    payload: res.data,
                });

                if (updateQuery) toast.success("Account updated successfully.");
                else toast.success("Account added successfully.");
                dispatch(fetchCompetitorList());

                return res.data;
            })
            .catch((err) => {
                toast.error(err.response.data.message);
                dispatch({
                    type: "JOIN_COMPETITOR_ACCOUNT_REJECTED",
                    payload: err.response.data,
                });
                throw err;
            });
    };
}

export const fetchCompetitorFollowersOvertime = (params, query_id) => {
    return async (dispatch) => {
        dispatch({
            type: "FETCH_COMPETITOR_FOLLOWERS_PENDING",
            payload: query_id,
        });
        try {
            const response = await fetchFollowersCount(params);
            const data = formatFollowersChart(response.data);

            dispatch({
                type: "FETCH_COMPETITOR_FOLLOWERS_FULFILLED",
                payload: { ...data, query_id },
            });
        } catch (error) {
            console.log(error);
            dispatch({
                type: "FETCH_COMPETITOR_FOLLOWERS_REJECTED",
                payload: query_id,
            });
        }
    };
};

const formatFollowersCount = (response) => {
    const presentData = response.find((obj) => obj.name === "presentDurationData");
    const prevData = response.find((obj) => obj.name === "previousDurationData");

    const result = [];
    presentData.data?.forEach((obj) => {
        const presentFollowers = obj.follower_info?.total;

        const individualResult = {
            platform: obj.platform,
            username: obj.username,
            followers: presentFollowers,
            previousFollowers: 0,
            followersGrowth: 0,
        };
        let previousObj = prevData.data?.find((oldObj) => oldObj.platform === obj.platform && oldObj.username === obj.username);
        const prevFollowers = previousObj?.follower_info?.total;

        if (prevFollowers) {
            // const growth = (((presentFollowers - prevFollowers) / presentFollowers) * 100).toFixed(2);
            const growth = presentFollowers - prevFollowers;
            individualResult.followersGrowth = +growth;
        }
        individualResult.previousFollowers = prevFollowers;
        result.push(individualResult);
    });
    return result;
};

const formatFollowersChart = (resp) => {
    const tz = JSON.parse(localStorage.company).user_timezone_name;
    const data = { nodata: false, lineChartData: [] };
    const nonZeroValue = new Set();

    resp?.results?.forEach((obj, index) => {
        data.nodata = obj.follower_info?.total === 0;
        data.lineChartData = obj.follower_info?.buckets?.map((d) => {
            let followersCount = d.followersCount;
            if (followersCount !== 0) {
                nonZeroValue.clear();
                nonZeroValue.add(followersCount);
            }
            if (followersCount == 0 && index === resp?.results.length - 1) {
                followersCount = [...nonZeroValue][0] || 0;
            }
            let date = +moment(d.date).tz(tz).format("x");
            return [date, followersCount];
        });
    });

    return data;
};
